var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarCarouselIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2709 3.44339L9.82264 1.04966C9.06835 -0.196816 7.17022 0.503255 7.38296 1.94987L7.7915 4.72713C7.93732 5.71862 6.9992 6.51667 6.06109 6.19887L3.43345 5.30871C2.0649 4.84521 1.0549 6.61842 2.13512 7.58771L4.20922 9.44885C4.94947 10.1133 4.73715 11.3359 3.81679 11.7036L1.23955 12.7336C-0.10256 13.2699 0.248148 15.2864 1.69023 15.3253L4.45955 15.3999C5.44807 15.4263 6.06067 16.5015 5.58893 17.3829L4.26788 19.8511C3.57968 21.1365 5.12751 22.4529 6.25689 21.5427L8.42559 19.7954C9.19971 19.1716 10.3506 19.5961 10.548 20.5784L11.1011 23.3297C11.3891 24.7625 13.4095 24.7625 13.6974 23.3297L14.2505 20.5784C14.448 19.5961 15.5988 19.1716 16.3729 19.7954L18.5416 21.5427C19.671 22.4525 21.2184 21.1365 20.5306 19.8511L19.2096 17.3829C18.7378 16.5019 19.3505 15.4267 20.339 15.3999L23.1083 15.3253C24.5508 15.2864 24.9015 13.2699 23.559 12.7336L20.9817 11.7036C20.0618 11.3359 19.849 10.1133 20.5893 9.44885L22.6634 7.58771C23.7436 6.61842 22.7336 4.84521 21.3651 5.30871L18.7374 6.19887C17.7997 6.51667 16.8612 5.71862 17.007 4.72713L17.4156 1.94987C17.6283 0.503255 15.7302 -0.196816 14.9759 1.04966L13.5276 3.44339C13.0108 4.29796 11.7856 4.29796 11.2689 3.44339H11.2709Z",
    fill: "#FFAEAC",
    stroke: "#1C173A",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarCarouselIcon);
export default __webpack_public_path__ + "static/media/star_carousel_icon.90ebaf45d6b94f69c82d3221e997c018.svg";
export { ForwardRef as ReactComponent };